(() => {
  document.querySelectorAll('[data-kimo-follow-lazy]').forEach(host => {
    const template = host.querySelector('template');
    if (!template) return;
    const mount = () => {
      if (!template.isConnected) return;
      const fragment = template.content.cloneNode(true);
      fragment.querySelectorAll('script').forEach(oldScript => {
        const script = document.createElement('script');
        [...oldScript.attributes].forEach(attribute => script.setAttribute(attribute.name, attribute.value));
        script.textContent = oldScript.textContent;
        oldScript.replaceWith(script);
      });
      template.replaceWith(fragment);
    };
    if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
      mount();
      return;
    }
    const observer = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      observer.disconnect();
      mount();
    }, {rootMargin: '400px'});
    observer.observe(host);
  });
})();
